var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTermometr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6869 6.31227V5.81592H18.295V5.99879C17.8248 5.73755 17.0933 5.76367 16.6492 6.02491L15.2646 6.80862L16.9627 7.56622L18.3473 6.7825C18.5824 6.65188 18.6869 6.49514 18.6869 6.31227Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31554 10.8578C7.68857 11.2235 6.06889 12.4513 6.06889 12.4513L4.55371 13.5485V14.0449C7.53183 12.3207 9.02089 12.1901 9.98747 11.6154L16.7274 7.72292V7.22657L15.0555 6.96533L8.31554 10.8578Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9629 7.5923L16.7539 7.72292V7.22657L16.9629 7.12207V7.5923Z",
    fill: "#16A89F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6492 5.34566L15.2646 6.12938L16.9627 7.12208L18.3473 6.33837C18.8175 6.07713 18.8175 5.63303 18.3473 5.37179C17.877 5.0583 17.1194 5.0583 16.6492 5.34566Z",
    fill: "#F3F3F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31556 10.1525C7.32285 10.7272 7.11386 11.5631 4.13574 13.2873L4.57985 13.5486C7.55796 11.8244 9.04702 11.6938 10.0136 11.119L16.7536 7.22659L15.0555 6.26001L8.31556 10.1525Z",
    fill: "#F3F3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2998 13.8359V14.3062C3.2998 14.3584 3.32593 14.4107 3.4043 14.4368C3.53492 14.5152 3.71779 14.5152 3.84841 14.4368L4.57987 14.0188V13.5225L3.2998 13.8359Z",
    fill: "#D1D3D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40461 13.7053C3.27399 13.7837 3.27399 13.8882 3.40461 13.9666C3.53522 14.0449 3.71809 14.0449 3.84871 13.9666L4.58018 13.5486L4.13607 13.2874L3.40461 13.7053Z",
    fill: "#E6E7E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9627 7.1221L16.7537 7.22659L15.0557 6.26001L15.2647 6.12939L16.9627 7.1221Z",
    fill: "#24D2C1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6451 7.25279L10.8759 8.84634C10.4841 9.05533 10.4841 9.42107 10.8759 9.65618C11.2678 9.86517 11.8686 9.86517 12.2605 9.65618L15.0296 8.06263C15.4215 7.85364 15.4215 7.4879 15.0296 7.27891C14.6378 7.01767 14.0369 7.01767 13.6451 7.25279Z",
    fill: "#24D2C1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0552 7.749C15.0291 7.64451 14.9507 7.54001 14.794 7.43552C14.5066 7.25265 14.0625 7.22653 13.8013 7.38327L11.9987 8.42822C11.8942 8.48047 11.842 8.55884 11.842 8.63722C11.8159 8.53272 11.8681 8.42822 11.9987 8.37598L13.8013 7.33102C14.0625 7.2004 14.5066 7.2004 14.794 7.38327C14.9768 7.48777 15.0552 7.61839 15.0552 7.749Z",
    fill: "#16A89F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0555 7.74917C15.0555 7.82754 15.0033 7.90592 14.8988 7.95816L13.0962 9.00312C12.835 9.15986 12.3909 9.13373 12.1035 8.95087C11.9468 8.8725 11.8684 8.74188 11.8423 8.63738C11.8423 8.55901 11.8945 8.48064 11.999 8.42839L13.8016 7.38344C14.0628 7.22669 14.5069 7.25282 14.7943 7.43569C14.951 7.54018 15.0294 7.64468 15.0555 7.74917Z",
    fill: "#E6E7E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.626 8.29761V8.32373L12.9133 8.5066H12.9917V8.45435L12.7043 8.29761H12.626Z",
    fill: "#535359"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9917 8.50659V8.53272L13.2791 8.71558H13.3574V8.66333L13.0701 8.50659H12.9917Z",
    fill: "#535359"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.626 8.71558H12.7043L12.9917 8.53272V8.50659H12.9133L12.626 8.66333V8.71558Z",
    fill: "#535359"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2603 8.5066H12.3386L12.626 8.32373V8.29761H12.5476L12.2603 8.45435V8.5066Z",
    fill: "#535359"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7754 7.48779V7.51392L13.8799 7.56617H13.9321L13.8015 7.48779H13.7754Z",
    fill: "#535359"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9326 7.56617H13.9587L14.0632 7.51392V7.48779H14.0371L13.9326 7.56617Z",
    fill: "#535359"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7754 7.4878H13.8015L13.9321 7.43555V7.40942H13.8799L13.7754 7.4878Z",
    fill: "#535359"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9917 8.92457H13.0701L13.3574 8.7417V8.71558H13.2791L12.9917 8.87232V8.92457Z",
    fill: "#535359"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7754 7.64453V7.67065L14.0628 7.85352H14.1411V7.80127L13.8538 7.64453H13.7754Z",
    fill: "#535359"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1411 7.85352V7.87964L14.4285 8.06251H14.4807V8.01026L14.1934 7.85352H14.1411Z",
    fill: "#535359"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7754 8.06251H13.8538L14.1411 7.87964V7.85352H14.0628L13.7754 8.01026V8.06251Z",
    fill: "#535359"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4097 7.85352H13.488L13.7754 7.67065V7.64453H13.697L13.4097 7.80127V7.85352Z",
    fill: "#535359"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1411 8.27149H14.1934L14.4807 8.08863V8.0625H14.4285L14.1411 8.21924V8.27149Z",
    fill: "#535359"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7827 8.19312V8.24536L13.0701 8.40211H13.1484V8.37598L12.8611 8.19312H12.7827Z",
    fill: "#535359"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 7.98413V8.03638L13.4358 8.19312H13.5142V8.167L13.2268 7.98413H13.1484Z",
    fill: "#535359"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5142 8.19312V8.24536L13.8015 8.40211H13.8799V8.37598L13.5925 8.19312H13.5142Z",
    fill: "#535359"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 8.40211H13.2268L13.5142 8.24536V8.19312H13.4358L13.1484 8.37598V8.40211Z",
    fill: "#535359"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7827 8.19312H12.8611L13.1484 8.03638V7.98413H13.0701L12.7827 8.167V8.19312Z",
    fill: "#535359"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5142 8.61109H13.5925L13.8799 8.45435V8.4021H13.8015L13.5142 8.58497V8.61109Z",
    fill: "#535359"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0894 8.32373L14.011 8.37598L13.9326 8.32373L14.011 8.27148L14.0894 8.32373Z",
    fill: "#535359"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermometr);
export default __webpack_public_path__ + "static/media/termometr.6fbd892f333c661516d5deee361260f3.svg";
export { ForwardRef as ReactComponent };